import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const C = motion[as];
  return (
    <C className={className} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease, delay }} {...rest}>
      {children}
    </C>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p className={`overline-hw flex items-center gap-3 ${light ? "text-[#8CAFC0]" : "text-[#344C59]"}`}>
    <span className={`w-8 h-px ${light ? "bg-[#8CAFC0]" : "bg-[#344C59]"}`} />{children}
  </p>
);

export const H2 = ({ children, light = false, className = "" }) => (
  <h2 className={`font-heading font-normal text-[2.5rem] leading-[1.06] md:text-[3.4rem] lg:text-[3.9rem] ${light ? "text-[#F4F1E9]" : "text-[#172B38]"} ${className}`}>{children}</h2>
);
